module.exports = __webpack_public_path__ + "static/00002.e1ed403e.jpg";